// src/utils/f.ts
// import { computed } from 'vue';
import { Modal, Input } from 'ant-design-vue';
import { h, ref } from 'vue'; // 需要用 h 函数创建虚拟节点，ref 管理输入值
import { message as AntMessage } from 'ant-design-vue'; // 关键：加别名
import { v4 as uuidv4 } from 'uuid';
import * as XLSX from 'xlsx';


// 导入原有的Storage工具（如果你的ls是自己写的，直接把ls的逻辑复制到这里也可以）
import ls from './Storage';

export const MUTATION_TYPES = {
  USER_INFO: 'USER_INFO' // 对应你原来的USER_INFO常量
};

// --------------------------
// 2. 集成：存储工具（封装ls，不用再单独导入ls）
// --------------------------
export const Storage = {
  get: (key: string) => ls.get(key),
  set: (key: string, value: any) => ls.set(key),
  remove: (key: string) => ls.remove(key),
  clear: () => ls.clear()
};

// 定义 SysInfo 类
export class sysInfo {
  public static DefaultDB: string = 'SYS';
  public static SystemDB: string = 'SYS';
  public static DllName: string = '';
  // public static CaptionIniFile: string = '';
  // public static appPath: string = '';
  // public static serverIP: string = '';
  // public static dbName: string = '';
  // public static dbUserName: string = '';
  // public static dbPassWord: string = '';

  // public static UserRoleGroupID: number = 0;
  // public static UserRoleGroupName: string = '';
  // public static dbFile: string = '';
  // public static AlOneMode: boolean = false;
  // public static appDebugMode: boolean = false;
  // public static redisServer: string = '';
  // public static RedisPort: number = 0;
  // public static isDebug: boolean = false;
  // public static isStop: boolean = false;
  // public static isConnectionFail: boolean = false;
  // public static isFinish: boolean = false;
  public static GiTime: number = 0;
  // public static bShowType: boolean = false;
  // public static runLogFile: string = '';
  // public static errLogFile: string = '';
  // public static HospitalArea: string = '';
  // public static LogerLevel: string = '';
  public static HostName: string = '';
  public static HostIP: string = '';
  // public static SystemType: number = 0; // 0 for 病案系统, 1 for 电子病历
  public static UserRoleGroupList: { [key: string]: string } = {};

  //
  public static token: string = '';         //token
  public static UserID: string = '';        //工号
  public static UserName: string = '';      //名称
  public static UserGUID: string = '';      //用户GUID
  public static BaseGroupGUID: string = ''; //组ID
  public static DeptName: string = '';      //科室名称
  public static GroupName: string = '';     //组名称
  public static UnitName: string = '';      //单位名称
  public static Sex: string = '';      //0未知1男2女
  
  // 新增
  public static CurrModule: string = '';      //模块名称
  public static CurrModuleID: string = '';    //模块ID
  public static CurrModulePath: string = '';  //模块路径
  public static CurrItem: string = '';        //当前项目
  public static CurrRoute: string = '';       //当前路由
  public static BaseUrl : string = '';       //基础地址
  public static HomeUrl : string = '';       //返回首页地址

  public static DefaultPageUrl : string = '';       //MainPage地址 

  
  public static Start:boolean=false;        //是否已启动
  

  // 获取应用程序的可执行路径
  public static get exePath(): string {
    return window.location.href; // 获取当前页面的完整 URL
  }

  // 获取应用程序的运行路径
  public static get runPath(): string {
    return window.location.origin; // 获取当前页面的根路径
  }
}

export class SQLParaStruct {
  public Name: string;
  public Value: any; // 使用 any 类型，因为 Value 的类型可能多种多样
  public Type: string; // 使用字符串表示类型，因为 TypeScript 中没有 SqlDbType 枚举
  public Remarks:string;
  public Required:number;
  public ReadOnly:number;
  public Hidden:number;

  
  constructor(name: string, value: any, type: string,remarks:string='',required:boolean=true,readonly:boolean=false,hidden:boolean=false) {
    this.Name = name;
    this.Value = value;
    this.Type = type;
    this.Remarks=remarks;
    this.Required=required? 1 : 0; // 布尔值转换为数字
    this.ReadOnly=readonly? 1 : 0; // 布尔值转换为数字
    this.Hidden=hidden ? 1 : 0; // 布尔值转换为数字

  }
}


export class SqlParameter {
  public static readonly SQLDataType = {
    Varchar: "varchar",
    Money: "money",
    Float: "float",
    Int: "integer",
    Datetime: "datetime",
    false: "float",
    NVarchar: "nvarchar",
    Date: "date",
    Bit: "bit"
  } as const;  
  private Para: SQLParaStruct[] = [];

  public clear(): void {
    this.Para = [];
  }

  public add(type: string, name: string, value: any): void {
    const aPara = new SQLParaStruct(name, value, type,'',true,false,false);
    this.Para.push(aPara);
  }

  public addItem(type: string, name: string, value: any,remarks:string,required:boolean,readonly:boolean,hidden:boolean): void {
    const aPara = new SQLParaStruct(name, value, type,remarks,required,readonly,hidden);
    this.Para.push(aPara);
  }  

  public get sqlParameters(): any[] {
    const parameters: any[] = [];

    for (const para of this.Para) {
      const p1 = {
        Name: para.Name,
        Type: para.Type,
        Value: para.Value,
        Remarks:para.Remarks,
        Required:para.Required,
        ReadOnly:para.ReadOnly,
        Hidden:para.Hidden
      };
      parameters.push(p1);
    }

    return parameters;
  }
}
// export default class F {
//   constructor() {
//     // this.name = name;
//   }
// }
// export default class F {

  const logConfig = {
    enable: process.env.NODE_ENV !== 'production',
    showDebug: true,
    showInfo: true,
    showWarn: true,
    showError: true
  };
export default class F {
  public static Error: string = '';      //模块名称    
  public static SQLPrint: string = '';      //模块名称    
  // ========== 新增：模式标记静态属性（私有，通过方法控制） ==========
  private static _bAdd: boolean = false; // 新增标记
  private static _bEdit: boolean = false; // 修改标记

  static operateType = {
    add: 'ADD',
    edit: 'EDIT',
    delete: 'DELETE'
  };

  public static findNode(treeData, targetKey) {
    if (!treeData || !targetKey) return null;

    for (const node of treeData) {
      if (node.key === targetKey) return node;
      if (node.children && node.children.length) {
        const result = F.findNode(node.children, targetKey);
        if (result) return result;
      }
    }
    return null;
  }

  /**
   * 查找指定节点的父节点
   */
  public static findParentNode(treeData, targetKey) {
    if (!treeData || !targetKey) return null;

    const traverse = (nodes, parent) => {
      for (const node of nodes) {
        if (node.key === targetKey) return parent;
        if (node.children && node.children.length) {
          const result = traverse(node.children, node);
          if (result) return result;
        }
      }
      return null;
    };

    return traverse(treeData, null);
  }  

    // 新增：全局静态 writeErroLog 方法（复用 logger.info 处理日志内容）
  public static writeErroLog(message: string | Record<string, any>, ...extra: any[]) {
    // 1. 统一日志前缀：[ERROR-LOG] 标识错误日志，方便筛选
    const logMessage = `[ERROR-LOG] ${message}`;
    // 2. 复用 logger.info 的逻辑输出日志（保持格式/开关一致）
    this.logger.info(logMessage, ...extra);
  }

  public static strToIntDef = (str: string, def = 0) => {
    const num = parseInt(str || '', 10);
    return isNaN(num) ? def : num;
  };
 // ========== 新增：基于 operateType 的当前操作类型（替代单独的 bAdd/bEdit） ==========
  private static _currentOperate: string = ''; // 存储当前操作类型（ADD/EDIT/DELETE）

  // ========== 重构模式控制方法（基于 operateType，兼容你要的 addMode/editMode 调用） ==========
  /** 切换为新增模式（映射 operateType.add） */
  public static addMode(): void {
    F._currentOperate = F.operateType.add;
    F.logger.debug(`[F.addMode] 切换为新增模式 → currentOperate=${F.operateType.add}`);
  }

  /** 切换为修改模式（映射 operateType.edit） */
  public static editMode(): void {
    F._currentOperate = F.operateType.edit;
    F.logger.debug(`[F.editMode] 切换为修改模式 → currentOperate=${F.operateType.edit}`);
  }

  /** 切换为删除模式（可选，映射 operateType.delete） */
  public static deleteMode(): void {
    F._currentOperate = F.operateType.delete;
    F.logger.debug(`[F.deleteMode] 切换为删除模式 → currentOperate=${F.operateType.delete}`);
  }

  /** 重置操作模式（弹窗关闭时调用） */
  public static resetMode(): void {
    F._currentOperate = '';
    F.logger.debug(`[F.resetMode] 重置操作模式 → currentOperate=''`);
  }

  // ========== 兼容你原有习惯：暴露 bAdd/bEdit 只读属性（基于 currentOperate 推导） ==========
  public static get bAdd(): boolean {
    return F._currentOperate === F.operateType.add;
  }
  public static get bEdit(): boolean {
    return F._currentOperate === F.operateType.edit;
  }
  public static get bDelete(): boolean {
    return F._currentOperate === F.operateType.delete;
  }
    
// ========== 新增：日志工具（静态属性，挂载到 F 类） ==========
  public static logger = {
    debug: (message: string | Record<string, any>, ...extra: any[]) => {
      if (logConfig.enable && logConfig.showDebug && process.env.NODE_ENV !== 'production') {
        console.debug(`[${new Date().toLocaleTimeString()}] [DEBUG]`, message, ...extra);
      }
    },
    info: (message: string | Record<string, any>, ...extra: any[]) => {
      if (logConfig.enable && logConfig.showInfo) {
        console.info(`[${new Date().toLocaleTimeString()}] [INFO]`, message, ...extra);
      }
    },
    warn: (message: string | Record<string, any>, ...extra: any[]) => {
      if (logConfig.enable && logConfig.showWarn) {
        console.warn(`[${new Date().toLocaleTimeString()}] [WARN]`, message, ...extra);
      }
    },
    error: (message: string | Record<string, any>, ...extra: any[]) => {
      if (logConfig.enable && logConfig.showError) {
        console.error(`[${new Date().toLocaleTimeString()}] [ERROR]`, message, ...extra);
      }
    }
  };

  // ========== 新增：日志配置（静态属性，支持动态修改） ==========
  public static logConfig = logConfig;
  // --------------------------
  // 新增：用户信息相关方法（集成到F类中）
  // --------------------------
  // 6.1 获取本地存储的用户信息
  static getUserInfo() {
    return Storage.get(MUTATION_TYPES.USER_INFO) || {};
  }

  // 6.2 同步用户信息到 sysInfo 类（一键同步，不用重复写赋值逻辑）
  static syncUserInfoToSysInfo() {
    const userInfo = this.getUserInfo();
    // 同步到 sysInfo 静态属性（和你的 sysInfo 字段一一对应）
    sysInfo.UserID = userInfo.username || '';
    sysInfo.UserName = userInfo.name || '';
    sysInfo.token = userInfo.token || '';
    sysInfo.DeptName = userInfo.deptname || '';
    sysInfo.UnitName = userInfo.unitname || '';
    sysInfo.UserGUID = userInfo.id || ''; // 按你的实际字段映射
    // 其他需要同步的字段，按 sysInfo 定义添加
  }

  static getItem(itemname="",defaultValue=""){
    const value = localStorage.getItem(itemname)||defaultValue;
    return value;
  }
  /**
   * 对传入的字符串进行 URI 编码
   * @param str - 要编码的字符串，默认为空字符串
   * @returns 编码后的字符串
   */
  static guid() {
    return uuidv4();
  }
  /**
   * 对传入的字符串进行 URI 编码
   * @param str - 要编码的字符串，默认为空字符串
   * @returns 编码后的字符串
   */
  static ecode(str=""){
    return encodeURIComponent(str);
  }
  //表格部分全局函数
  static getTableRowIndex(keyField: string, data: any[], guid: string): number {
    // 遍历当前层级的数据
    for (let i = 0; i < data.length; i++) {
      // 使用 keyField 参数动态访问对象属性
      if (data[i][keyField] === guid) {
        return i; // 返回当前索引
      }
  
      // 如果当前项有 children，递归检查
      if (data[i].children && data[i].children.length > 0) {
        const index = F.getTableRowIndex(keyField, data[i].children, guid); // 使用 F.getRowIndex
        if (index !== -1) {
          return index; // 如果在子层级中找到，返回索引
        }
      }
    }
  
    return -1; // 如果未找到匹配项，返回 -1
  }

  /**
   * 映射value到对应的label（极简命名版）
   * @param value 要匹配的值
   * @param options 下拉选项数组
   * @returns 映射后的label，无匹配返回原value
   */
  static mapLabel(
    value: string | undefined | null,
    options: Array<{ value: string; label: string }>
  ): string {
    const targetValue = value != null ? String(value) : '';
    if (!targetValue || !Array.isArray(options) || !options.length) {
      return targetValue;
    }
    const targetOption = options.find(opt => String(opt.value) === targetValue);
    return targetOption ? targetOption.label : targetValue;
  }  

  static delTableRow(keyField: string, data: any[], guid: string): number {
    // 遍历当前层级的数据
    for (let i = 0; i < data.length; i++) {
      // 使用 keyField 参数动态访问对象属性
      if (data[i][keyField] === guid) {
        data.splice(i, 1);
        return i; // 返回当前索引
      }
  
      // 如果当前项有 children，递归检查
      if (data[i].children && data[i].children.length > 0) {
        const index = F.delTableRow(keyField, data[i].children, guid); // 使用 F.getRowIndex
        if (index !== -1) {
          return index; // 如果在子层级中找到，返回索引
        }
      }
    }
  
    return -1; // 如果未找到匹配项，返回 -1
  }

  static formatDate(date: Date): string {
    if (!date) return '';
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

// 支持自定义格式的日期时间格式化（适配表格列渲染）
// 支持自定义格式的日期时间格式化（适配表格列渲染）
static formatDateTime = (value: any, format: string = 'yyyy-MM-dd HH:mm:ss') => {
  // 1. 取原始值（兼容 value 本身或 value.value 的结构）
  const rawValue = value?.value ?? value;

  // 2. 处理空值
  if (!rawValue && rawValue !== 0) return '';

  // 3. 解析日期
  let dateObj = new Date(rawValue);

  // 4. 修复带T的格式
  if (dateObj.toString() === 'Invalid Date' && typeof rawValue === 'string') {
    dateObj = new Date(rawValue.replace('T', ' '));
  }

  // 5. 校验无效时间
  if (dateObj.toString() === 'Invalid Date') {
    return '无效时间';
  }

  // ========== 新增核心逻辑：提取并支持「固定时间值」覆盖 ==========
  // 先提取原始日期的年月日时分秒
  let year = dateObj.getFullYear();
  let month = dateObj.getMonth() + 1;
  let day = dateObj.getDate();
  let hours = dateObj.getHours();
  let minutes = dateObj.getMinutes();
  let seconds = dateObj.getSeconds();

  // 解析 format 中的「固定值」（如 00:00:00），覆盖原始时分秒
  // 匹配格式：HH:mm:ss 或 固定值（如 00:00:00）
  const timeMatch = format.match(/(\d{2}):(\d{2}):(\d{2})/);
  if (timeMatch) {
    const [_, hh, mm, ss] = timeMatch;
    // 如果是数字（不是占位符 HH/mm/ss），则强制覆盖时间
    if (hh !== 'HH') hours = Number(hh);
    if (mm !== 'mm') minutes = Number(mm);
    if (ss !== 'ss') seconds = Number(ss);
  }

  // 解析 format 中的「固定日期值」（如 2025-11-27），可选增强
  const dateMatch = format.match(/(\d{4})-(\d{2})-(\d{2})/);
  if (dateMatch) {
    const [_, yyyy, MM, dd] = dateMatch;
    if (yyyy !== 'yyyy') year = Number(yyyy);
    if (MM !== 'MM') month = Number(MM);
    if (dd !== 'dd') day = Number(dd);
    // 重新生成日期对象（避免月份/日期越界）
    dateObj = new Date(year, month - 1, day, hours, minutes, seconds);
  }

  // 6. 格式化补零（对齐规范）
  const yearStr = year.toString();
  const monthStr = String(month).padStart(2, '0');
  const dayStr = String(day).padStart(2, '0');
  const hoursStr = String(hours).padStart(2, '0');
  const minutesStr = String(minutes).padStart(2, '0');
  const secondsStr = String(seconds).padStart(2, '0');

  // 7. 根据 format 参数替换占位符（保留原有逻辑）
  return format
    .replace('yyyy', yearStr)    // 4位年份
    .replace('MM', monthStr)     // 2位月份
    .replace('dd', dayStr)       // 2位日期
    .replace('HH', hoursStr)     // 24小时制
    .replace('mm', minutesStr)   // 2位分钟
    .replace('ss', secondsStr)   // 2位秒
    .replace('SS', secondsStr);  // 兼容旧SS写法
};

  static getDate(): string {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  static getDateTime(): string {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // 月份从 0 开始，需要加 1
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
  
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  static getToken(store: any): any {
    return store.state.auth.token;
    // return computed(() => store.state.auth.token).value;
  }

  static getUserCode(store: any): any {
    return store.state.auth.code;
    // return computed(() => store.state.auth.code).value;
  }

  static indexCol(
    width: number = 60,
    align: 'left' | 'center' | 'right' = 'center',
    headerAlign: 'left' | 'center' | 'right' = 'center',
    key: string = 'serialNumber'
  ) {
    return {
      title: '序号',
      width,
      align,
      headerAlign,
      key,
      dataIndex: '',
      customRender: (value: any) => {
        // 从AntD表格行信息中获取索引，value.index为行索引（从0开始）
        const realIndex = value?.index ?? 0;
        // 索引+1作为序号，确保为数字类型
        return Number(realIndex) + 1;
      }
    };
  }

  static showMessage(content: string): void {
    // f.showMessage("你好!");
    Modal.info({
      title: '消息', // 标题
      content: content, // 消息内容
      okText: '确 定', // 确认按钮文本
      // 可选：点击确认按钮后的回调（如果需要）
      onOk: () => {
        console.log('用户点击了确定');
      }
    });
  }
  static confirm(content: string): Promise<boolean> {
    //调用实例
    // const result = await f.confirm('确定要执行此操作吗？');
    // if (result) {
    //   console.log('用户点击了确定');
    // } else {
    //   console.log('用户点击了取消');
    // }      
    return new Promise((resolve) => {
      Modal.confirm({
        title: '询问', // 标题
        content: content, // 提示内容
        cancelText: ' 取 消 ', // 取消按钮文本
        okText: ' 确 定 ', // 确认按钮文本
        closable: false, // 隐藏右上角关闭按钮（对应 showClose: false）
        maskClosable: false, // 点击遮罩层不关闭（对应 closeOnClickModal: false）
        keyboard: false, // 按 ESC 不关闭（对应 closeOnPressEscape: false）
        // 点击确认按钮
        onOk: () => {
          resolve(true);
        },
        // 点击取消按钮
        onCancel: () => {
          resolve(false);
        }
      });
    });
  }

  static input(title: string, content: string, defaultValue = ''): Promise<string | null> {
    // 调用实例
    // const result = await f.input('请输入名称', '请填写要修改的名称：', '默认值');
    // if (result !== null) {
    //   console.log('用户输入：', result);
    // } else {
    //   console.log('用户取消输入');
    // }  

    return new Promise((resolve) => {
      // 用 ref 管理输入框的值（初始值为 defaultValue）
      const inputValue = ref(defaultValue);
  
      Modal.confirm({
        title: title, // 标题
        // 自定义内容：先显示提示文本，再显示输入框
        content: () => h('div', null, [
          h('p', null, content), // 提示文本（对应 message 参数）
          h(Input, {
            value: inputValue.value,
            onChange: (e: Event) => {
              // 同步输入框值到 ref
              inputValue.value = (e.target as HTMLInputElement).value;
            },
            placeholder: '请输入内容',
            style: { marginTop: '0px' }
          })
        ]),
        cancelText: '取消',
        okText: '确定',
        closable: false, // 隐藏右上角关闭按钮
        maskClosable: false, // 点击遮罩不关闭
        keyboard: false, // 禁止 ESC 关闭
        // 点击确定按钮时校验
        onOk: () => {
          if (!inputValue.value.trim()) {
            // 输入为空时阻止关闭并提示
            Modal.error({ content: '输入内容不能为空' });
            return false; // 返回 false 阻止弹窗关闭
          }
          resolve(inputValue.value); // 输入有效，返回值
        },
        // 点击取消按钮
        onCancel: () => {
          resolve(null);
        }
      });
    });
  }

// 修改 f.ts 中的 show 方法，用 requestAnimationFrame 实现精准计时
static show(content: string, type: 'info' | 'success' | 'error' | 'warning' = 'info', duration = 3000): void {
  // 显示提示并保存关闭函数
  const closeFunc = AntMessage[type]({
    content: content,
    duration: 0, // 禁用组件自带定时器
  });

  // 用 requestAnimationFrame 实现高精度计时
  let start = 0;
  const step = (timestamp: number) => {
    if (!start) start = timestamp;
    const progress = timestamp - start;
    if (progress >= duration) {
      closeFunc(); // 时间到，关闭提示
    } else {
      requestAnimationFrame(step); // 继续等待
    }
  };
  requestAnimationFrame(step); // 启动计时
}

  static tableHeaderBgStyle = {
    //列头样式
      backgroundColor: '#cce8ff',
      color: '#000',
      fontSize: '12px',
      fontWeight: '700',
      textAlign: 'center',
      padding: '8px'
  };

  static success(content: string, duration = 3000): void {
    this.show(content, 'success', duration);
  }

  static error(content: string, duration = 3000): void {
    this.show(content, 'error', duration);
  }

  static warning(content: string, duration = 3000): void {
    this.show(content, 'warning', duration); // 注意这里用 'warn' 而非 'warning'
  }

  static info(content: string, duration = 3000): void {
    this.show(content, 'info', duration);
  }

// replaceSqlPara.ts
static replaceSqlPara(sqlText: string, parameters: any[], replaceConstValue: boolean = true): string {
    let text = sqlText;

    // 替换参数
    if (parameters) {
      parameters.forEach((param) => {
        const { Name, Value, Type } = param;
        let replacement: string;

        switch (Type.toLowerCase()) {
          case 'varchar':
          case 'nvarchar':
          case 'char':
          case 'nchar':
          case 'ntext':
          case 'text':
            replacement = Value != null ? `'${Value.toString().replace(/'/g, "''")}'` : 'NULL';
            break;
          case 'datetime':
          case 'datetime2':
          case 'date':
            if (Value == null || Value === '') {
              replacement = 'NULL';
            } else {
              const dateTime = new Date(Value);
              replacement = `'${dateTime.toISOString().replace('T', ' ').substring(0, 19)}'`;
            }
            break;
          case 'time':
            if (Value == null) {
              replacement = 'NULL';
            } else {
              replacement = `'${Value.toString()}'`;
            }
            break;
          case 'int':
          case 'bigint':
          case 'money':
          case 'float':
            replacement = Value != null ? Value.toString() : 'NULL';
            break;
          case 'bit':
            replacement = Value != null ? (Value ? '1' : '0') : 'NULL';
            break;
          default:
            replacement = Value != null ? Value.toString() : 'NULL';
        }

        text = text.replace(new RegExp(`\\{${Name}\\}`, 'g'), replacement);
      });
    }

    // 替换常量值
    if (replaceConstValue) {
      text = text.replace(/\{USERID\}/g, 'sysInfo.UserID');
      text = text.replace(/\{USERNAME\}/g, 'sysInfo.UserName');
      text = text.replace(/\{USERROLE\}/g, 'sysInfo.UserRoleGroupID');
      text = text.replace(/\{HOSTNAME\}/g, 'sysInfo.HostName');
      text = text.replace(/\{HOSTIP\}/g, 'sysInfo.HostIP');
    }

    return text;
  }  

    /**
   * 导出表格数据为 Excel
   * @param {Array} data - 表格源数据（a-table 的 dataSource）
   * @param {Array} columns - 表格列配置（a-table 的 columns，需包含 title + dataIndex）
   * @param {string} fileName - 导出的文件名（默认：表格数据.xlsx）
   */
static exportTableToExcel = (
  data: any[],
  columns: any[],
  fileName: string = '表格数据.xlsx'
) => {
  // 1. 参数校验
  const validData = Array.isArray(data) ? [...data] : [];
  const validColumns = Array.isArray(columns) ? [...columns] : [];
  const exportColumns = validColumns.filter(col => col?.title && col?.dataIndex);

  if (exportColumns.length === 0) {
    console.error('导出失败：无有效列配置（需包含 title 和 dataIndex）');
    return;
  }

  // 2. 构造表头和数据行
  const headers = exportColumns.map(col => col.title);
  const rows = validData.map((item, rowIndex) => {
    return exportColumns.map(col => {
      let cellValue = '';

      // 修复序号列：手动生成行号
      if (col.dataIndex === 'index' || col.title === '序号') {
        cellValue = rowIndex + 1;
      }
      // 处理嵌套字段
      else if (col.dataIndex.includes('.')) {
        cellValue = col.dataIndex.split('.').reduce((obj, key) => obj?.[key], item) || '';
      }
      // 处理自定义渲染
      else if (typeof col.customRender === 'function') {
        const renderResult = col.customRender({ record: item, text: item[col.dataIndex], index: rowIndex });
        cellValue = renderResult?.toString() || item[col.dataIndex] || '';
      }
      // 普通字段兜底
      else {
        cellValue = item[col.dataIndex] || '';
      }

      // ========== 核心修复：日期列统一去除毫秒 ==========
      const isDateColumn = ['时间', '日期', 'DTime', 'createTime', 'updateTime'].some(key => 
        col.title?.includes(key) || col.dataIndex === key
      );
      
      if (isDateColumn) {
        // 情况1：cellValue是13位时间戳（数字/字符串）
        if (/^\d{13}$/.test(cellValue.toString())) {
          const date = new Date(Number(cellValue));
          // 转成无毫秒的格式：yyyy-MM-dd HH:mm:ss
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          const hours = String(date.getHours()).padStart(2, '0');
          const minutes = String(date.getMinutes()).padStart(2, '0');
          const seconds = String(date.getSeconds()).padStart(2, '0');
          cellValue = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        }
        // 情况2：已是字符串（含毫秒），直接截取到秒（去除 .xxx 部分）
        else if (typeof cellValue === 'string' && cellValue.includes('.')) {
          cellValue = cellValue.split('.')[0]; // 截取到秒，移除毫秒
        }
      }

      // 所有值转为字符串（最终兜底）
      cellValue = cellValue.toString();

      return cellValue;
    });
  });

  // 3. 生成 Excel 工作簿 + 强制文本格式（杜绝科学计数法）
  const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
  const range = XLSX.utils.decode_range(worksheet['!ref'] || 'A1:A1');
  for (let row = range.s.r; row <= range.e.r; row++) {
    for (let col = range.s.c; col <= range.e.c; col++) {
      const colLetter = String.fromCharCode(65 + col);
      const cellAddress = `${colLetter}${row + 1}`;
      if (worksheet[cellAddress]) {
        worksheet[cellAddress].t = 's'; // 文本类型
        worksheet[cellAddress].z = '@'; // Excel文本格式
      }
    }
  }

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'sheet1');

  // 4. 下载文件（解决中文文件名乱码）
  try {
    const encodeFileName = encodeURIComponent(fileName) + '.xlsx';
    const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([wbout], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = decodeURIComponent(encodeFileName);
    link.click();
    
    URL.revokeObjectURL(link.href);
    console.log('Excel 导出成功');
  } catch (e) {
    XLSX.writeFile(workbook, `${encodeURIComponent(fileName)}.xlsx`);
    console.error('Excel 导出异常，已降级处理:', e);
  }
};

  static isNotDangerSQL(sSQL:string) {
    if (!sSQL) {
      return true;
    }
  
    const s1 = sSQL.toLowerCase();
    if (s1.includes("delete ")) {
      return s1.includes("where ");
    }
    if (s1.includes("update ")) {
      return s1.includes("where ");
    }
    if (s1.includes("drop ")) {
      return s1.includes("where ");
    }
    return true;
  }  
  static formatLongToTimeStr = (milliseconds:number) => {
    const seconds = Math.floor(milliseconds / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
  
    const remainingSeconds = seconds % 60;
    const remainingMinutes = minutes % 60;
  
    return `${hours}小时${remainingMinutes}分钟${remainingSeconds}秒`;
  };  
  static RunTime = (ibyte = 0, style = 0, remark = '') => {
    if (sysInfo.GiTime === 0) {
      sysInfo.GiTime = Date.now(); // 如果 GiTime 未初始化，设置为当前时间
      return '';
    }
  
    if (ibyte > 0) {
      const iTime = Date.now() - sysInfo.GiTime; // 计算运行时间
      sysInfo.GiTime = Date.now(); // 更新 GiTime 为当前时间
  
      switch (style) {
        case 0:
          return `[${ibyte}][${remark}]运行时间: ${iTime} 毫秒`;
        case 1:
          return `耗时：${F.formatLongToTimeStr(iTime)}`;
        case 2:
          return F.formatLongToTimeStr(iTime);
        default:
          return `[${ibyte}]运行时间: ${iTime} 毫秒`;
      }
    } else {
      sysInfo.GiTime = Date.now(); // 重置 GiTime
    }
  
    return '';
  };
  

}

// --------------------------
// 7. 自动初始化：页面加载时同步用户信息到 sysInfo
// --------------------------
F.syncUserInfoToSysInfo();